<!-- 头部视频位 -->
<template>
  <div v-if="mediaInfo.isShow" class="video-box" @click="$goFundApp">
    <img :src="mediaInfo.media.pic" class="video-img"/>
    <img :src="playBtn" class="play-btn" />
  </div>
</template>

<script>
export default {

  name: 'header-video',

  props: {
    cfhInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      playBtn: 'https://j5.dfcfw.com/sc/image/202204/20220419051147.png',
    };
  },

  computed: {
    mediaInfo() {
      const mediaInfo = this.cfhInfo?.mediaInfo || {};
      return { isShow: !this.$isEmpty(mediaInfo.pic), media: mediaInfo };
    },
  },
};
</script>

<style lang="less" scoped>
.video-box {
  width: 100%;
  position: relative;
}
.video-img {
  background-color: #e93801;
  border-radius: 12px;
  width: 100%;
}
.play-btn {
  position: absolute;
  top: calc(50% - 40px);
  left: calc(50% - 40px);
  width: 80px;
  height: 80px;
}
</style>
